const businessTradeInGoods = [
  {
    expand: false,
    children: [
      {
        value: 37,
        label: '1.珠宝钟表, 珍珠玉器'
      },
      {
        value: 38,
        label: '2.人造及仿制首饰'
      },
      {
        value: 39,
        label: '3.钱币古玩, 油画雕刻工艺品'
      }
    ],
    value: 0,
    label: '1.珠宝、钟表、古玩及工艺品'
  },
  {
    expand: false,
    children: [
      {
        value: 40,
        label: '1.水族、宠物护理用品'
      },
      {
        value: 41,
        label: '2.农药, 种植和园艺用品'
      }
    ],
    value: 1,
    label: '2.水族、宠物用品及农药'
  },
  {
    expand: false,
    children: [
      {
        value: 42,
        label: '1.烟草、酒精饮品'
      },
      {
        value: 43,
        label: '2.非酒精饮品'
      },
      {
        value: 44,
        label: '3.茶叶咖啡及可可'
      }
    ],
    value: 2,
    label: '3.烟草、酒精及非酒精饮品'
  },
  {
    expand: false,
    children: [
      {
        value: 4,
        label: '1.防锈剂, 润滑剂, 石蜡, 盐酸油漆染料'
      },
      {
        value: 5,
        label: '2.易燃品: 盐酸, 硫酸, 聚氯乙烯, 异丙醇, 甲醇等'
      }
    ],
    value: 3,
    label: '4.化学品及化学产品'
  },
  {
    expand: false,
    children: [
      {
        value: 45,
        label: '1.鞋, 成衣, 袋类'
      },
      {
        value: 46,
        label: '2.防护服, 安全面盔和检测工具'
      },
      {
        value: 47,
        label: '3.布料及附属用品'
      }
    ],
    value: 6,
    label: '5.鞋、成衣及附属用品'
  },
  {
    expand: false,
    children: [
      {
        value: 8,
        label: '1.谷物蔬菜及水果'
      },
      {
        value: 9,
        label: '2.乳类'
      },
      {
        value: 10,
        label: '3.肉类'
      },
      {
        value: 11,
        label: '4.鱼类及海产'
      },
      {
        value: 12,
        label: '5.粮食原材料'
      },
      {
        value: 48,
        label: '6.餐饮品供应  Food & Beverages'
      }
    ],
    value: 7,
    label: '6.食品饮料，粮食原材料'
  },
  {
    expand: false,
    children: [
      {
        value: 14,
        label: '1.书籍与文具'
      },
      {
        value: 15,
        label: '2.礼品, 印刷和包装'
      },
      {
        value: 16,
        label: '3.体育用品'
      },
      {
        value: 17,
        label: '4.玩具及电子游戏机'
      },
      {
        value: 18,
        label: '5.玩具制造'
      },
      {
        value: 49,
        label: '6.音乐和乐器'
      }
    ],
    value: 13,
    label: '7.文化及康乐商品'
  },
  {
    expand: false,
    children: [
      {
        value: 20,
        label: '1.家用电器灯饰影音'
      },
      {
        value: 21,
        label: '2.商用机械'
      },
      {
        value: 50,
        label: '3.警报防盗电锁'
      }
    ],
    value: 19,
    label: '8.电器设备'
  },
  {
    expand: false,
    children: [
      {
        value: 23,
        label: '1.摄影录音器材'
      },
      {
        value: 24,
        label: '2.眼镜及光学用品'
      },
      {
        value: 25,
        label: '3.电子通讯,手表和零件'
      }
    ],
    value: 22,
    label: '9.电子及光学产品'
  },
  {
    expand: false,
    value: 26,
    label: '10.羽毛及皮革制品'
  },
  {
    expand: false,
    children: [
      {
        value: 85,
        label: '1.防火和防护安全装备'
      },
      {
        value: 86,
        label: '2.各类蓄电池、 锂离子电池'
      }
    ],
    value: 27,
    label: '11.防火和防护安全装备'
  },
  {
    expand: false,
    children: [
      {
        value: 51,
        label: '1.家具,厨厕具'
      },
      {
        value: 52,
        label: '2.地毡窗帘镜器五金器具'
      }
    ],
    value: 28,
    label: '12.家具、厨厕具及固定装置'
  },
  {
    expand: false,
    value: 29,
    label: '13.燃气、石油及煤产品'
  },
  {
    expand: false,
    children: [
      {
        value: 53,
        label: '1.轻型工商业用机械'
      },
      {
        value: 54,
        label: '2.钻机,钻探机械和组件'
      },
      {
        value: 55,
        label: '3.橡胶塑料或合成材料机械和组件'
      },
      {
        value: 56,
        label: '4.车辆维修和配件备件'
      },
      {
        value: 57,
        label: '5.农业机设备及零件'
      },
      {
        value: 58,
        label: '6.建筑机械工具和卫生设备'
      },
      {
        value: 59,
        label: '7.建材, 水泥, 木材和材料加工'
      },
      {
        value: 60,
        label: '8.废金属, 杂物和废原材料'
      },
      {
        value: 61,
        label: '9.电池,引擎,涡轮机'
      }
    ],
    value: 30,
    label: '14.机械及设备'
  },
  {
    expand: false,
    children: [
      {
        value: 62,
        label: '1.医疗设备检测工具'
      },
      {
        value: 63,
        label: '2.物理治疗设备,药品和保健品'
      }
    ],
    value: 31,
    label: '15.医疗设备'
  },
  {
    expand: false,
    children: [
      {
        value: 64,
        label: '1.钢铁铜铝铅镍锡锌合金产制品'
      },
      {
        value: 65,
        label: '2.其他五金材料'
      }
    ],
    value: 32,
    label: '16.金属及非金属矿产制品'
  },
  {
    expand: false,
    value: 33,
    label: '17.矿物及其他原料'
  },
  {
    expand: false,
    children: [
      {
        value: 66,
        label: '1.通讯电子零件和产品'
      },
      {
        value: 67,
        label: '2.无线网络零件和产品'
      }
    ],
    value: 34,
    label: '18.通讯设备'
  },
  {
    expand: false,
    children: [
      {
        value: 68,
        label: '1. 家居清洁,个人护理,美妆品'
      }
    ],
    value: 35,
    label: '19.梳洗用品、化妆品及药物'
  },
  {
    expand: false,
    children: [
      {
        value: 69,
        label: '1.建材, 水泥, 木材和材料加工'
      }
    ],
    value: 36,
    label: '20.建筑原材料'
  }
]
export default businessTradeInGoods
